/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:12:23
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-19 10:34:45
 */
import req from "@/utils/request";

//  get 请求示列
export const countSiteOverview = (params) => req.post("/site-service/m/workbench/countSiteOverview", params);
export const selectListData = (params) => req.post("/site-service/m/workbench/selectListData", params);
export const selectJournalList = (params) => req.post("/site-service/m/workbench/selectJournalList", params);
export const countPending = (params) => req.post("/site-service/m/workbench/countPending", params);
export const selectManById = (params) => req.post("/manager-service/m/management/selectManById", params);
export const wordCloudAnalysis = (params) => req.post("/dataCenter-service/m/webOverview/wordCloudAnalysis", params);
export const countManuscriptTrends = (params) => req.post("/site-service/m/workbench/countManuscriptTrends", params);
export const countSiteManuscriptNumber = (params) => req.post("/site-service/m/workbench/countSiteManuscriptNumber", params);
export const findListPage = (params) => req.post("/interact-service/m/isUnknownQuestion/findListPage", params);
export const reminderFollowNumber = (params) => req.post("/site-service/m/workbench/reminderFollowNumber", params);
export const workbench = (params) => req.post("/monitor-service/m/monitor/workbench", params);
export const orgRanking = (params) => req.post("/manager-service/m/orgReports/selectOrgReportsRanking",params);

